import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../../common/types';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { reelReviewMessages } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The toast stays 8 s (design d2). */
export const REEL_TOAST_MS = 8000;

interface ReelApprovedToastProps {
  count: number;
  onHide: () => void;
}

/**
 * Design d2: the draft posts are in the Calendar, with a link to it. The app toasts carry no
 * in-app link, so the page shows this one itself.
 */
const ReelApprovedToastComponent: React.FC<ReelApprovedToastProps> = ({ count, onHide }) => {
  const intl = useIntl();
  const router = useSMLRouter();

  useEffect(() => {
    const timer = setTimeout(onHide, REEL_TOAST_MS);
    return () => clearTimeout(timer);
  }, [onHide]);

  return (
    <div className={styles.toast} role="status">
      <FontAwesomeIcon icon={faCheck} className={styles.toastIcon} />
      <span>{intl.formatMessage(reelReviewMessages.toast, { count })}</span>
      <button type="button" className="btn btn-link p-0 fw-bold" onClick={() => router.push(SMLRoutes.promoteCalendar)}>
        {intl.formatMessage(reelReviewMessages.openCalendar)}
      </button>
    </div>
  );
};

export const ReelApprovedToast = TypedMemo(ReelApprovedToastComponent);
